module.exports = __webpack_public_path__ + "static/media/ribosomal_seqs_distance_matrix.bc890364.csv";